import React, { ReactNode } from 'react';
import styles from './assets/invoicesChanges-screen.module.scss';
import classNames from 'classnames';
import InvoiceDocsGrid from './components/InvoiceDocsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IInvoiceDoc } from 'src/types/invoice';
import Loader from '../../../../../../components/Loader';
export interface StateProps {
    data: Paginated<IInvoiceDoc>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class InvoiceChangesList extends React.Component<Props, { active: number }> {
    //componentDidMount() {}
    constructor(props: Props) {
        super(props);
        this.state = {
            active: 0,
        };
    }
    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>
                        PENDING INVOICES {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <InvoiceDocsGrid data={data} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default InvoiceChangesList;
